import { render, staticRenderFns } from "./orderDetailList.vue?vue&type=template&id=2678741f&scoped=true"
import script from "./orderDetailList.vue?vue&type=script&lang=js"
export * from "./orderDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678741f",
  null
  
)

export default component.exports